import "@/App.css";
import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Reveal } from "@/components/Reveal";
import { Stats } from "@/components/Stats";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { Gallery } from "@/components/Gallery";
import { Videos } from "@/components/Videos";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Testimonials } from "@/components/Testimonials";
import { Recognition } from "@/components/Recognition";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import Admin from "@/pages/Admin";

const Home = () => (
  <div className="min-h-screen bg-[#0B131F]">
    <Header />
    <main>
      <Hero />
      <Marquee />
      <Reveal>
        <Stats />
      </Reveal>
      <Reveal>
        <Services />
      </Reveal>
      <Reveal>
        <About />
      </Reveal>
      <Reveal>
        <Videos />
      </Reveal>
      <Reveal>
        <Gallery />
      </Reveal>
      <Reveal>
        <BeforeAfter />
      </Reveal>
      <Reveal>
        <Testimonials />
      </Reveal>
      <Reveal>
        <Recognition />
      </Reveal>
      <Reveal>
        <QuoteForm />
      </Reveal>
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let frameId;
    const raf = (time) => {
      lenis.raf(time);
      frameId = requestAnimationFrame(raf);
    };
    frameId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frameId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
